<div class="apelacion-documentos-container">
    <div class="header-section">
        <h1 class="page-title">
            <i class="bi bi-exclamation-circle-fill"></i>
            Apelación de Resolución
        </h1>
        <p class="page-description">
            Presenta tu apelación a la resolución de evaluación de salud irrecuperable.
            Adjunta los documentos de respaldo en formato PDF o ZIP.
        </p>
        <div *ngIf="funcionario" class="mt-3 p-3 bg-light rounded border text-success small">
            <i class="bi bi-check-circle"></i>
            Funcionario cargado: {{ funcionario.exp_nombre_fun }} {{ funcionario.exp_apellido_paterno_fun }} (ID Exp: {{ funcionario.exp_id }})
        </div>
    </div>
    <div class="info-section">
        <div class="info-card">
            <i class="bi bi-info-circle-fill"></i>
            <div>
                <h5>Información importante sobre apelaciones</h5>
                <ul>
                    <li>Debes presentar un motivo claro y fundamentado para tu apelación</li>
                    <li>Adjunta toda la documentación médica que respalde tu apelación</li>
                    <li>Solo se aceptan archivos en formato PDF o ZIP</li>
                    <li>El tamaño máximo por archivo es de 20MB</li>
                    <li>Puedes subir hasta {{ maxFiles }} archivos a la vez</li>
                    <li>Una vez enviada, recibirás una confirmación y número de seguimiento</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="upload-card">
        <!-- Appeal Description -->
        <div class="form-group mb-4">
            <label for="apelacionMotivo" class="form-label">
                <i class="bi bi-pencil-square"></i>
                Motivo de la Apelación
            </label>
            <textarea id="apelacionMotivo" class="form-control" rows="5" [(ngModel)]="apelacionMotivo"
                placeholder="Describe detalladamente el motivo de tu apelación..." [disabled]="isUploading"></textarea>
            <small class="form-text text-muted">
                Explica claramente las razones por las cuales estás apelando la resolución.
            </small>
        </div>

        <!-- Drag and Drop Area -->
        <div class="drop-zone" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" (click)="fileInput.click()">

            <div class="drop-zone-content">
                <i class="bi bi-cloud-arrow-up drop-icon"></i>
                <h3 class="drop-title">Arrastra tus documentos de respaldo aquí</h3>
                <p class="drop-text">o haz clic para seleccionar</p>
                <div class="file-types">
                    <span class="badge badge-pdf">
                        <i class="bi bi-file-pdf"></i> PDF
                    </span>
                    <span class="badge badge-zip">
                        <i class="bi bi-file-zip"></i> ZIP
                    </span>
                </div>
                <small class="text-muted">Máximo {{ maxFiles }} archivos • Tamaño máximo 20MB por archivo</small>
            </div>

            <input #fileInput type="file" [accept]="accept" multiple (change)="onFileSelect($event)"
                style="display: none;">
        </div>

        <!-- File List -->
        <div *ngIf="selectedFiles.length > 0" class="file-list">
            <div class="file-list-header">
                <h4>
                    <i class="bi bi-files"></i>
                    Documentos adjuntos ({{ selectedFiles.length }}/{{ maxFiles }})
                </h4>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="clearAll()">
                    <i class="bi bi-trash"></i> Limpiar todo
                </button>
            </div>

            <div class="files-grid">
                <div *ngFor="let file of selectedFiles; let i = index" class="file-item">
                    <div class="file-icon" [style.color]="getFileIconColor(file.name)">
                        <i class="bi" [ngClass]="getFileIcon(file.name)"></i>
                    </div>
                    <div class="file-info">
                        <div class="file-name" [title]="file.name">{{ file.name }}</div>
                        <div class="file-size">{{ formatFileSize(file.size) }}</div>
                    </div>
                    <button type="button" class="btn-remove" (click)="removeFile(i)" title="Eliminar archivo">
                        <i class="bi bi-x-circle-fill"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Upload Progress -->
        <div *ngIf="isUploading" class="upload-progress">
            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    [style.width.%]="uploadProgress" [attr.aria-valuenow]="uploadProgress" aria-valuemin="0"
                    aria-valuemax="100">
                    {{ uploadProgress }}%
                </div>
            </div>
            <p class="text-center mt-2 text-muted">Enviando apelación...</p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
            <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()"
                [disabled]="selectedFiles.length === 0 || !apelacionMotivo.trim() || isUploading">
                <i class="bi bi-send"></i>
                Enviar Apelación
            </button>
            <button type="button" class="btn btn-outline-secondary btn-lg" routerLink="/inicio"
                [disabled]="isUploading">
                <i class="bi bi-arrow-left"></i>
                Volver
            </button>
        </div>
    </div>

    <!-- Info Section -->

</div>